<template>
  <div class="the-navbar__user-meta flex items-center" v-if="true">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-medium text-sm">{{ vendor.VendorName }}</p>
      <small class="font-normal">{{ vendor.rfc }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <vs-avatar
        color="rgb(188, 19, 0)"
        :text="vendor.VendorName"
        width="40"
        height="40"
        class="rounded-full shadow-md cursor-pointer block"
      />

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="width: 15rem">
          <li
            class="
              flex
              py-2
              px-4
              cursor-pointer
              hover:bg-primary hover:text-white
            "
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t('logout') }}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {
      vendor: {
        VendorName: '',
        rfc: '',
      },
    }
  },
  mounted(){
    this.vendor = JSON.parse(localStorage.getItem('vendor'))
  },
  methods: {
    logout() {
      localStorage.removeItem('vendor')
      this.$router.push('/')
    },
  },
}
</script>
